import getNextFocusable from '../accessibility/focus/get-next-focusable';

const $ = jQuery;

const accessibleFormSubmitController = () => {
	if (typeof Marionette !== 'undefined' && typeof nfForms !== 'undefined') {
		const formSubmitController = Marionette.Object.extend({
			initialize() {
				this.listenTo(Backbone.Radio.channel('submit'), 'render:view', this.handleSubmit);
			},
			handleSubmit(model) {
				if (typeof model !== 'undefined') {
					const wrapper = $(model.el);
					const button = wrapper.find('.nf-field-element input');
					button.prop('disabled', false);
				}
			},
		});
		return new formSubmitController();
	}

	return null;
};

/**
 * @function init
 * @description Kick off this modules functions. Do not load for mobiles
 */

const init = () => {
	$(document).on('nfFormReady', (e, model) => {
		accessibleFormSubmitController(model);
		document.addEventListener('nf-form-loaded-in-popup', accessibleFormSubmitController);
	});
	$(document).on('blur', '.ninja-forms-field', (e) => {
		setTimeout(() => {
			if ((document.activeElement === document.body) && (e.relatedTarget !== document.body)) {
				const nextFocusable = getNextFocusable(e.currentTarget);
				if (nextFocusable) {
					nextFocusable.focus();
				}
			}
		}, 50);
	});
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/accessible-submit-button.js